<template>
  <div class='CheckoutSideBot01'>
    <div class="total">
      <div class="label">SubTotal</div>
      <div class="value">{{ CheckoutTotal01.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="total">
      <div class="label">Desconto</div>
      <div class="value">{{ cupom.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="total">
      <div class="label">Total</div>
      <div class="value">{{ ((CheckoutTotal01 + ValorFrete) - cupom.valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <input-gift/>
    <div class="continue">
      <label class="cont-nue" @click="close">Continuar comprando</label>
    </div>
    <button @click="complete"
    :style="{
      backgroundColor: Prefes.btn.corBackground,
      color: Prefes.btn.corFont,
      fontFamily: Prefes.btn.font,
      fontStyle: parseInt(Prefes.btn.fontStyle) ? 'italic' : '',
      fontWeight: parseInt(Prefes.btn.fontBold) ? 'bold' : '',
      textDecoration: parseInt(Prefes.btn.textDecoration) ? 'underline' : '',
      fontSize: Prefes.btn.fontHeight + 'px'
    }"
    >
      Finalizar a Compra
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputGift from '../Client/InputGift'
export default {
  name: 'CheckoutSideBot01',
  components: { InputGift },
  props: ['out'],
  emits: ['update:out'],
  computed: {
    ...mapGetters(['CheckoutItens01', 'CheckoutTotal01', 'Prefes', 'cupom', 'ValorFrete'])
  },
  methods: {
    complete () {
      this.$emit('update:out', true)
      this.$router.push('/complete')
    },
    close () {
      this.$emit('update:out', true)
    }
  }
}
</script>

<style scoped>
.CheckoutSideBot01 {
  width: 80%;
  height: 20%;
  margin: auto;
  border-top: thin solid #CCCCCC;
}

.total {
  display: flex;
  justify-content: center;
  padding: 4%;
}

.label {
  width: 50%;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
}

.value {
  width: 50%;
  text-align: right;
  font-size: 18px;
}

button {
  width: 92%;
  height: 35%;
  border: 0;
  background-color: orange;
  color: #FFFFFF;
  border-radius: 5px;
  font-size: 18px;
}

.continue {
  padding: 3%;
}

.cont-nue {
  cursor: pointer;
  color: #056ac8;
}
</style>
